import React from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Custom Components
import NotificationMessage from "./notification-message.component";

// Styles
import "./notification.styles.scss";

const normalizeNotificationMessage = message => {
  if (!message) return null;
  if (Array.isArray(message)) {
    const items = message
      .map(item => {
        if (typeof item === "string" && item.trim()) return item;
        if (item?.message) return item.message;
        return null;
      })
      .filter(Boolean);
    return items.length ? items : null;
  }
  if (typeof message === "string") {
    return [message];
  }
  if (message?.errors) {
    const errors = message.errors;
    return Array.isArray(errors) ? errors : [errors];
  }
  if (message?.message) {
    return [{ message: message.message }];
  }
  return [{ message: "Something went wrong. Please try again." }];
};

const Notification = {
  success: (message, { position = "top-right", autoClose = 5000 } = {}) => {
    const normalized = normalizeNotificationMessage(message);
    if (!normalized) return;
    toast.info(<NotificationMessage message={normalized} />, {
      position,
      autoClose,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      draggablePercent: 1,
      progress: undefined
    });
  },
  error: (
    message,
    { position = "bottom-right", autoClose = 5000, onClick = () => {} } = {}
  ) => {
    const normalized = normalizeNotificationMessage(message);
    if (!normalized) return;
    toast.error(<NotificationMessage message={normalized} />, {
      position,
      autoClose,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      draggablePercent: 1,
      progress: undefined,
      onClick: onClick
    });
  }
};

export default Notification;